import { render, staticRenderFns } from "./dialogTable.vue?vue&type=template&id=0b28b810&scoped=true"
import script from "./dialogTable.vue?vue&type=script&lang=js"
export * from "./dialogTable.vue?vue&type=script&lang=js"
import style0 from "./dialogTable.vue?vue&type=style&index=0&id=0b28b810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b28b810",
  null
  
)

export default component.exports